import { useDispatch, useSelector } from 'react-redux';
import { nextStep, prevStep, jumpToStep } from '../../store/slices/stepBuilderSlice';

export const useStepBuilder = () => {
  const dispatch = useDispatch();
  const { current, total } = useSelector(state => state.stepBuilder);

  return {
    current,
    total,
    next: () => dispatch(nextStep()),
    prev: () => dispatch(prevStep()),
    jump: (step) => dispatch(jumpToStep(step))
  };
};